import BaseModel from "@/models/BaseModel";

export enum CustomerType {
    PERSON = 1,
    COMPANY = 2,
    PRIVATEFIRM = 3
}

export default class CustomerModel extends BaseModel {
    public static isPerson(customerType: number) {
        return customerType === CustomerType.PERSON;
    }

    public static isCompany(customerType: number) {
        return customerType > CustomerType.PERSON;
    }

    public static isPrivateFirm(customerType: number) {
        return customerType === CustomerType.PRIVATEFIRM;
    }
}

export interface Customer {
    info: {
        id: number;
        referenceNo: string;
        idNo: string;
        name: string;
        adress1: string;
        adress2: string;
        city: string;
        postNo: string;
        customerType: number;
        externReference: string;
        countryCode: string;
        tag: string;
    };
    system: {
        businessType: string;
        country: {
            countryName: string;
        };
    };
}
